export default __webpack_public_path__ + "static/media/kamivest_icon_badge.e6fd13ca.svg";